import React from 'react';
import { Group } from '../../../primitives/Group/Group.es.js';
import PaginationButton from './PaginationButton.es.js';

const Truncated = ({
  buttonComponent,
  startRange,
  endRange,
  currentPage,
  buttonSize,
  shape,
  goToPage
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, startRange.map((page, i) => {
  return /* @__PURE__ */ React.createElement(PaginationButton, {
    buttonComponent,
    key: `${i}${page}`,
    isSelected: currentPage === page,
    buttonSize,
    shape,
    page,
    onClick: () => goToPage(page),
    itemType: "number"
  }, page);
}), /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(PaginationButton, {
  buttonComponent,
  buttonSize,
  shape,
  itemType: "ellipsis"
}, "...")), endRange.map((page, i) => {
  return /* @__PURE__ */ React.createElement(PaginationButton, {
    buttonComponent,
    key: `${i}${page}`,
    isSelected: currentPage === page,
    buttonSize,
    shape,
    page,
    onClick: () => goToPage(page),
    itemType: "number"
  }, page);
}));

export { Truncated as default };
//# sourceMappingURL=Truncated.es.js.map
